import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FutureAssessmentQuestions,
  futureAssignment,
} from "../../../../Redux/test/test.action";
import { formatDateandTime } from "../../../../utils/utils";
import { staticIcons } from "../../../../utils/assessmentSubjectIcons";
import { useNavigate } from "react-router-dom";
import ToastMessage from "../../../../utils/toasts/toastMessage";
import Loader from "../../../../utils/loader/loader";

export const FutureAssignments = () => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const [futureAssgnData, setFutureAssgnData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isTestExpire, setIsTextExpire] = useState(null);

  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  // const isMobile = window.innerWidth <= 768;
  const isMobile =
  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
  window.innerWidth <= 768;

  const futureAssgnStore = useSelector(
    (state) => state?.TestManager?.futureAssignment,
  );

  const store = useSelector(
    (state) => state?.TestManager?.futureAssignmentQuestions,
  );

  useEffect(() => {
    dispatch(futureAssignment());
  }, [dispatch]);

  useEffect(() => {
    if (futureAssgnStore) {
      const processedData = futureAssgnStore?.filter(
        (item) => new Date() < new Date(item?.end_time),
      );

      setFutureAssgnData(processedData);
    }
  }, [futureAssgnStore]);

  const iconMap = useMemo(() => {
    const map = {};
    staticIcons?.forEach((s) => {
      map[s.subject.toLowerCase()] = s.img;
    });
    return map;
  }, [staticIcons]);

  // const handleShowQuestions = async (e, assignment_id, expired) => {
  //   e.preventDefault("assignment_id", assignment_id);

  //   if (!assignment_id) {
  //     setToastState({
  //       show: true,
  //       message: "No assessment ID found!",
  //       type: "error",
  //     });
  //     return;
  //   }

  //   setLoading(true);
  //   const payload = {
  //     assignment_id: assignment_id,
  //   };

  //   const result = await dispatch(FutureAssessmentQuestions(payload));

  //   if (result?.success === true) {
  //     setLoading(false);

  //     const testData = futureAssgnData?.filter((a)=>a?.assignment_id === result?.data?.assignment_id)

  //     nav("/future-test", { state: testData });
  //   } else {
  //     const errorContext = result?.resp?.response?.data?.detail;
  //     setLoading(false);
  //     setToastState({
  //       show: true,
  //       message: errorContext || "No assessment ID found!",
  //       type: "error",
  //     });
  //   }
  // };

  const handleShowQuestions = async (e, assignment_id, expired) => {
  e.preventDefault();

  if (!assignment_id) {
    setToastState({
      show: true,
      message: "No assessment ID found!",
      type: "error",
    });
    return;
  }

  setLoading(true);
  const payload = {
    assignment_id: assignment_id,
  };

  const result = await dispatch(FutureAssessmentQuestions(payload));

  setLoading(false);

  if (result?.success === true) {
    const testData = futureAssgnData?.filter(
      (a) => a?.assignment_id === result?.data?.assignment_id
    );

    nav("/future-test", { state: testData });
  } else {
    setToastState({
      show: true,
      message: result?.resp || "No assessment ID found!",
      type: "error",
    });
  }
};
  return (
    <div
      className="main-block-assignments hide-below-768 mt-3"
      id="main-block-assignments"
    >
      <div className="title-row">
        <h4 className="fw900 ff2 fz28">Future Assignments</h4>

        {futureAssgnData?.length === 0 && (
          <div className="title-row__right">
            <div className="form-group form-group--search">
              <input
                autoComplete="off"
                type="search"
                id="searchCards"
                className="border-0 fz18 fw500 form-control"
                role="search"
                placeholder="Search..."
                style={{
                      padding: "12px 40px 12px 40px",
                      height: "48px",
                    }}
              />
              <img
                src="./assets/images/inner-pages/icons/icon-search.svg"
                alt=""
              />
            </div>

            <div style={{ position: "relative" }}>
              <button
                className="p-0 border-0 btn btn-round btn-round--navy bg-dark calendar-white-input"
                id="datepicker"
              >
                <img
                  src="./assets/images/inner-pages/icons/icon-calendar-white.svg"
                  alt=""
                />
              </button>
            </div>

            <div className="dropdown">
              <button
                className="py-0 border-0 btn btn-solid btn-solid--dark dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
              >
                <span className="fw500 lh1 fz18">Select</span>
                <img
                  className="dd-icon"
                  src="./assets/images/inner-pages/icons/icon-dropdown-arrow-white.svg"
                  alt=""
                />
              </button>

              <div className="mt-1 bdrs10 dropdown-menu">
                <ul className="m-0 ff2 list-unstyled">
                  {["Python", "Angular", "React", "All"].map((lang, i) => (
                    <li key={i}>
                      <div className="ps-0 fw500 fz16 checkbox-container">
                        <input
                          id={`slang-${i}`}
                          type="radio"
                          name="s-lang"
                          className="lang-input"
                        />
                        <label htmlFor={`slang-${i}`}>
                          <b />
                          {lang}
                        </label>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>

      {futureAssgnData?.length > 0 ? (
        <ul className="list-inline my-4 assignment-cards hide-below-768">
          {futureAssgnData.map((d, i) => (
            <li key={i}>
              <div className="a-card">
                <div className="a-card__top">
                  <div className="left">
                    <h5 className="m-0 fz24 card-title">{d?.subject}</h5>
                  </div>

                  <div className="right right--math">
                    <img
                      src={iconMap[d?.subject?.toLowerCase()]}
                      //  src={staticIcons?.find((s)=>s?.subject?.toLowerCase() === d?.subject?.toLowerCase())?.img}
                      alt=""
                    />
                  </div>
                </div>

                <div className="a-card__bottom">
                  <p className="fz16 fw400 inner">
                    {`Here you can get the questions related to ${d?.chapter}. Questions can be mcqs(multiple choice questions), short answers or fill in the blanks. Try to attempt all the questions.`}
                  </p>

                  <div className="other-info">
                    <div className="other-info__inner">
                      <div className="left">
                        <img
                          src="./assets/images/inner-pages/icons/icon-clock--blue.svg"
                          alt=""
                        />
                        <span className="ff2 fw500 fz16">
                          {`${d?.duration} mins`}
                        </span>
                        <span className="ff2 fw500 fz16 mx-2">
                          {formatDateandTime(d?.start_time)}
                        </span>
                      </div>
                    </div>

                    <div
                      className="right"
                      onClick={(e) =>
                        handleShowQuestions(e, d?.assignment_id, d?.expired)
                      }
                    >
                        {isMobile ? 
                  <p className="text-danger">
                    Tests can only be attempted on a desktop or laptop.
                  </p> :     <button
                        className="border-0 btn btn-solid btn-solid--dark fz16 fw500 ff2"
                        disabled={d?.expired}
                      >
                        Start Test
                      </button>
}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="bdrs40 data-empty-state">
          <h2 className="fz24 fw700 ff2">
            Oh Snap! No Future assignment available yet!
          </h2>

          <img
            className="empty-state-img"
            src="./assets/images/inner-pages/test-empty-illustration.svg"
            alt="empty state"
          />

          <p className="grayText">
            Looks like you haven’t uploaded an assignment yet. To stay on track
            and keep your progress visible of your assignments click on upload
            assignment.
          </p>
        </div>
      )}
      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </div>
  );
};
